import React from "react";
import moment from "moment";

const Deceased = ({ data, summary: isSummary, extensions: extensions }) => {
  if (isSummary) {
    const sourceCode = extensions
      ? extensions.filter(e => e.url.includes("deceasedSrcCode"))
      : "";
    if (typeof data === "boolean" && data === true) {
      return (
        <div>
          Deceased {sourceCode[0] ? "[" + sourceCode[0].valueString + "]" : ""}
        </div>
      );
    }
    return (
      <div>
        Deceased: {data && moment(data).format("L")}{" "}
        {sourceCode[0] ? "[" + sourceCode[0].valueString + "]" : ""}
      </div>
    );
  }
  return (
    <div>
      <h4>Deceased</h4>
      <div>
        {typeof data === "string"
          ? moment(data).format("L")
          : typeof data === "boolean" && data
          ? "Yes"
          : "No"}
      </div>
    </div>
  );
};

export default Deceased;
